import React, { useState } from "react"
import Modal from "../shared/Modal"
import { formatTimestamp } from "../../helpers/download"

const SaveResourceModal = ({ title, defaultPrefix, onSave, onClose, children }) => {
  const [name, setName] = useState(`${defaultPrefix}_${formatTimestamp()}`)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  const handleSave = async () => {
    const trimmedName = name.trim()
    if (!trimmedName) {
      setError("Please enter a name")
      return
    }

    setSaving(true)
    setError(null)

    const apiError = await onSave(trimmedName)
    setSaving(false)

    if (apiError) {
      setError(apiError)
      return
    }

    onClose()
  }

  const footer = (
    <>
      <button
        className="btn-base btn-secondary modal-btn"
        onClick={onClose}
        disabled={saving}
        title="Cancel without saving"
      >
        Cancel
      </button>
      <button
        className="btn-base btn-primary modal-btn"
        onClick={handleSave}
        disabled={saving || !name.trim()}
        title="Save to your account"
      >
        {saving ? "Saving..." : "Save"}
      </button>
    </>
  )

  return (
    <Modal title={title} onClose={onClose} footer={footer}>
      {error && <div className="error-message modal-error">{error}</div>}
      {children}
      <input
        type="text"
        className="input-base modal-input"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={`Enter ${defaultPrefix.toLowerCase()} name`}
        disabled={saving}
        autoFocus
        onKeyDown={(e) => e.key === "Enter" && handleSave()}
      />
    </Modal>
  )
}

export default SaveResourceModal
